module.exports = __webpack_public_path__ + "static/media/shutterstock_547860448.f26b5699.jpg";